import { render, staticRenderFns } from "./content-channel.vue?vue&type=template&id=2a2f0000&scoped=true&"
import script from "./content-channel.vue?vue&type=script&lang=ts&"
export * from "./content-channel.vue?vue&type=script&lang=ts&"
import style0 from "./content-channel.vue?vue&type=style&index=0&id=2a2f0000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f0000",
  null
  
)

export default component.exports